import type { ReactNode, HTMLAttributes } from 'react';
import clsx from 'clsx';
import styles from './Table.module.css';

/**
 * A minimal table wrapper that pairs with native <table> markup. Use this
 * to get the design-system look (borders, header row, row hover) without
 * pulling in a heavy data-grid yet. The full DataTable (sortable / inline
 * edit / virtualised) lands in a later phase per research §10.2.
 *
 * Usage:
 *   <Table>
 *     <thead>
 *       <tr><th>Company</th><th className="numeric">Price</th></tr>
 *     </thead>
 *     <tbody>
 *       <tr><td>Acme</td><td className="numeric">$1,000</td></tr>
 *     </tbody>
 *   </Table>
 */
export interface TableProps extends HTMLAttributes<HTMLTableElement> {
  /** Surround with a bordered Card-like wrapper. */
  bordered?: boolean;
  children: ReactNode;
}

export function Table({ bordered = true, className, children, ...rest }: TableProps) {
  return (
    <div className={clsx(styles.wrapper, bordered && styles.bordered)}>
      <table className={clsx(styles.table, className)} {...rest}>
        {children}
      </table>
    </div>
  );
}
